import moment from "moment";
import { Skeleton } from "primereact/skeleton";

export const APP_BASE_URL = "https://api.agriown.com";
//export const APP_BASE_URL = "http://localhost:3000";
// export const APP_BASE_URL =
//   "https://tvzjcz7x-5000.inc1.devtunnels.ms";

export const ASSET_PATH = APP_BASE_URL;

export const IMAGE_BASEURL = APP_BASE_URL + "front/assets/img/search_image.png";

// PAGINATION
//default pagination Row data
export const defaultRowOptions = 25;

//default PerPageRow options
export const defaultPageRowOptions = [10, 25, 50, 100];

//paginatior entries showing
export const showingEntries = "Showing {first} to {last} of {totalRecords}";

//paginator links & dropdown
export const paginatorLinks =
  "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown";

// PAGINATION

//date picker options
export const datePickerOptions = [
  { label: "Custom", value: "custom" },
  { label: "Today", value: "today" },
  { label: "Yesterday", value: "yesterday" },
  { label: "Last 7 days", value: "last7day" },
  { label: "Last 30 days", value: "last30days" },
  { label: "Last 90 days", value: "last90days" },
  { label: "Last month", value: "lastmonth" },
  { label: "Last year", value: "lastyear" },
  { label: "Week to date", value: "weektodate" },
  { label: "Month to date", value: "monthtodate" },
  { label: "Year to date", value: "yeartodate" },
];

// farmer status
export const farmerStatusOption = [
  { label: "Yes", value: true },
  { label: "No", value: false },
]

// service item Dropdown Options
export const itemTypeOptions = [
  { label: "Spray", value: "Spray" },
  { label: "Soil", value: "Soil" },
  { label: "Additional", value: "Additional" },
];

// Time of Day Dropdown Options
export const timeOfDayOptions = [
  { label: "Morning", value: "Morning" },
  { label: "Afternoon", value: "Afternoon" },
  { label: "Evening", value: "Evening" },
];

// status dropdown for operator
export const statusDropdownItems = [
  { name: "Active", code: "true" },
  { name: "In Active", code: "false" },
];

//booking status dropdown for operator
export const bookingStatusDropdownItems = [
  { name: "Pending", code: "Pending" },
  { name: "PreConfirmed", code: "PreConfirmed" },
  { name: "Cancelled", code: "Cancelled" },
  { name: "Completed", code: "Completed" },
  { name: "Confirmed", code: "Confirmed" },
  { name: "Reschedule", code: "Reschedule" },
];

// slot dropdown
export const slotDropdownItems = [
  { name: "Morning", code: "Morning" },
  { name: "Afternoon", code: "Afternoon" },
  { name: "Evening", code: "Evening" },
];

// service item dropdown
export const itemDropdownItems = [
  { name: "Spray", code: "Spray" },
  { name: "Soil", code: "Soil" },
  { name: "Additional", code: "Additional" },
];

// Dropdown For parameterOptions
export const parameterOptions = [
  { label: "EC", value: "ec" },
  { label: "OC", value: "oc" },
  { label: "N", value: "n" },
  { label: "P", value: "p" },
  { label: "K", value: "k" },
];

//Date Convert To YYYY/MM/DD
export function convertDateFrom(date: any) {
  return moment(date).format("YYYY-MM-DD");
}

//Date Convert To DD/MM/YYYY
export function convertDateFromTo(date: any) {
  return moment(date).format("DD-MM-YYYY");
}

export function getUTCStartOfDay(date: any) {
  return moment(date).startOf('day').format("YYYY-MM-DD HH:mm:ss");
}

export function getUTCEndOfDay(date: any) {
  return moment(date).endOf('day').format("YYYY-MM-DD HH:mm:ss");
}

// skeleton items & length
export const Skeletonitems: number[] = Array.from({ length: 10 }, (v, i) => i);

// SKELETON FOR COLUMN BODY
export function SkeletonbodyTemplate(): JSX.Element {
  return <Skeleton></Skeleton>;
}
